// extracted by mini-css-extract-plugin
export var actions = "_1u-0";
export var actionsContainer = "_1u-7";
export var border = "_1u-1";
export var childFullHeight = "_1u-f";
export var collapse = "_1u-2";
export var content = "_1u-a";
export var contentChild = "_1u-e";
export var fullscreen = "_1u-c";
export var hasLeftRadius = "_1u-k";
export var headerContainer = "_1u-3";
export var headerRow = "_1u-5";
export var hidePadding = "_1u-b";
export var navCollapsedGap = "_1u-l";
export var noScrollX = "_1u-m";
export var noScrollY = "_1u-n";
export var noTopPadding = "_1u-i";
export var optOutTopPadding = "_1u-d";
export var pageMain = "_1u-j";
export var pageOuter = "_1u-g";
export var pagePadding = "_1u-8";
export var pageScroll = "_1u-9";
export var profile = "_1u-o";
export var profileContainer = "_1u-p";
export var profileImage = "_1u-q";
export var profileMain = "_1u-r";
export var profileSubtitle = "_1u-t";
export var profileTitle = "_1u-s";
export var showLeftPadding = "_1u-h";
export var tabsPortalSlot = "_1u-6";
export var tabsWrapper = "_1u-4";
export var title = "_1u-u";